import './autocomplete.scss';
import autoComplete from 'pixabay-javascript-autocomplete';
import { AjaxLoader } from '../../js/ajax-loader';
import { dispatchForCode } from '../../js/helper';

class AjaxAutocomplete {
    constructor (element) {
        this.$ajaxInput = element;
        this.autocomplete = null;
        this.searchField = null;
        this.$form = this.$ajaxInput.closest('form');
        this.$searchError = this.$form.querySelector('[data-asset-search="error"]');
    }

    initialize () {
        if (this.$ajaxInput) {
            this.ajaxAutoComplete();
        }
    }

    ajaxAutoComplete () {
        const uri = this.$ajaxInput.getAttribute('data-asset-search-query-url');
        const CustomAutoComplete = autoComplete;

        this.$ajaxInput.addEventListener('keydown', (e) => {
            dispatchForCode(e, (code) => {
                if (code === 'Enter') {
                    const $autoSuggestions = document.querySelector('.autocomplete-suggestions');

                    if ($autoSuggestions) {
                        if ($autoSuggestions.querySelectorAll('.autocomplete-suggestion').length > 0) {
                            this.selectFirstLocation(true);
                        }
                        e.stopPropagation();
                        e.preventDefault();
                    } else {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }
            });
        });

        this.$ajaxInput.addEventListener('focus', () => {
            this.searchField = new CustomAutoComplete({
                selector: this.$ajaxInput,
                source: (term, response) => {
                    const formData = new FormData(this.$form);

                    new AjaxLoader(uri, { // eslint-disable-line
                        requestMethod: 'POST',
                        requestData: formData,
                        onSuccess: (result) => {
                            const data = JSON.parse(result);

                            if (data.error) {
                                this.$searchError.innerHTML = data.error;
                                this.$ajaxInput.classList.add('has--error');
                            } else {
                                this.$searchError.innerHTML = '';
                                this.$ajaxInput.classList.remove('has--error');
                                response(data.suggestions);
                            }
                        }
                    });
                },
                minChars: 2,
                renderItem: function (item, search) {
                    return '<div class="autocomplete-suggestion" data-val="' + search + '">' + item + '</div>';
                },
                onSelect: (e, term, item) => {
                    const link = item.querySelector('a');

                    if (link) {
                        window.location.href = link.href;
                    }
                }
            });
        });

        this.$ajaxInput.addEventListener('blur', () => {
            this.searchField.destroy();
        });
    }

    selectFirstLocation (withEnter) {
        let evt;
        if (document.documentElement.classList.contains('ie11')) {
            evt = document.createEvent('KeyboardEvent');
            evt.initKeyboardEvent('keydown', true, false, window, 'Down', 0, 0, 0, 0);
            this.$ajaxInput.dispatchEvent(evt);

            if (withEnter) {
                evt.initKeyboardEvent('Enter', true, false, window, 'Enter', 0, 0, 0, 0);
                this.$ajaxInput.dispatchEvent(evt);
            }
        } else if (document.documentElement.classList.contains('no-csshover')) {
            const Event1 = new Event('keydown');
            Event1.code = 'ArrowDown';
            Event1.key = 'ArrowDown';
            Event1.keyCode = 40;
            this.$ajaxInput.dispatchEvent(Event1);

            if (withEnter) {
                const Event2 = new Event('keydown');
                Event2.code = 'Enter';
                Event2.key = 'Enter';
                Event2.keyCode = 13;
                Event2.triggered = true;
                this.$ajaxInput.dispatchEvent(Event2);
            }
        } else {
            evt = new KeyboardEvent('keydown', { keyCode: 40, which: 40, code: 'ArrowDown' });
            this.$ajaxInput.dispatchEvent(evt);

            if (withEnter) {
                this.$ajaxInput.dispatchEvent(new KeyboardEvent('keydown', { keyCode: 13, which: 13, code: 'Enter' }));
            }
        }
    }
}

export { AjaxAutocomplete };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $ajaxAutocompleteInput = $context.querySelector('[data-asset-search="query"]');

        if ($ajaxAutocompleteInput) {
            const ajaxAutocomplete = new AjaxAutocomplete($ajaxAutocompleteInput);
            ajaxAutocomplete.initialize();
        }
    }
});
